"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localPaymentCheckoutSimulationResponseSchema = exports.localPaymentCheckoutSimulationRequestSchema = exports.localPaymentCheckoutSimulationOutcomeSchema = exports.localPaymentCheckoutSchema = exports.paymentWebhookAcknowledgementSchema = exports.requestFullPaymentRefundSchema = exports.invoicePaymentProcessingResponseSchema = exports.retryPaymentDisputeProviderEventRequestSchema = exports.submitPaymentDisputeEvidenceRequestSchema = exports.updatePaymentDisputeEvidenceRequestSchema = exports.assignPaymentDisputeRequestSchema = exports.paymentDisputeDetailResponseSchema = exports.paymentDisputeProviderEventDiagnosticSchema = exports.paymentDisputeActivitySchema = exports.paymentDisputeEvidenceItemSchema = exports.paymentDisputeListResponseSchema = exports.paymentDisputeListQuerySchema = exports.paymentDisputeListItemSchema = exports.paymentDisputeSchema = exports.providerPaymentSummarySchema = exports.paymentReconciliationCaseSchema = exports.paymentRefundSchema = exports.portalOnlinePaymentSchema = exports.portalPaymentSessionSchema = exports.createPortalPaymentSessionRequestSchema = exports.paymentOnboardingLinkSchema = exports.updatePaymentSettingsRequestSchema = exports.paymentSettingsResponseSchema = exports.paymentProviderAccountSchema = exports.paymentDisputeActivityTypeSchema = exports.paymentDisputeSubmissionStatusSchema = exports.paymentDisputeEvidenceStatusSchema = exports.paymentDisputeEvidenceKindSchema = exports.paymentDisputeStatusSchema = exports.paymentReconciliationStatusSchema = exports.paymentRefundStatusSchema = exports.portalOnlinePaymentStatusSchema = exports.paymentCheckoutStatusSchema = exports.paymentProviderAccountStatusSchema = exports.paymentProviderEnvironmentSchema = exports.paymentProviderKeySchema = exports.PAYMENT_DISPUTE_CONTRACT_VERSION = void 0;
const zod_1 = require("zod");
const pagination_1 = require("./pagination");
exports.PAYMENT_DISPUTE_CONTRACT_VERSION = 1;
exports.paymentProviderKeySchema = zod_1.z.enum(["local", "stripe_connect"]);
exports.paymentProviderEnvironmentSchema = zod_1.z.enum([
    "LOCAL",
    "SANDBOX",
    "LIVE",
]);
exports.paymentProviderAccountStatusSchema = zod_1.z.enum([
    "NOT_CONNECTED",
    "ONBOARDING_REQUIRED",
    "RESTRICTED",
    "ACTIVE",
    "DISABLED",
]);
exports.paymentCheckoutStatusSchema = zod_1.z.enum([
    "ACTIVE",
    "PROCESSING",
    "SUCCEEDED",
    "FAILED",
    "CANCELED",
    "EXPIRED",
    "REQUIRES_REVIEW",
]);
exports.portalOnlinePaymentStatusSchema = zod_1.z.enum([
    "PAYMENT_AVAILABLE",
    "PROCESSING",
    "PAID",
    "FAILED",
    "CANCELED",
    "REQUIRES_REVIEW",
    "PAYMENT_UNAVAILABLE",
]);
exports.paymentRefundStatusSchema = zod_1.z.enum([
    "REQUESTED",
    "PROCESSING",
    "SUCCEEDED",
    "FAILED",
]);
exports.paymentReconciliationStatusSchema = zod_1.z.enum([
    "OPEN",
    "RESOLVED_REFUNDED",
    "RESOLVED_MANUALLY",
    "RESOLVED_PROVIDER_WON",
]);
exports.paymentDisputeStatusSchema = zod_1.z.enum([
    "NEEDS_RESPONSE",
    "UNDER_REVIEW",
    "WON",
    "LOST",
    "CLOSED",
]);
exports.paymentDisputeEvidenceKindSchema = zod_1.z.enum([
    "CUSTOMER_COMMUNICATION",
    "SERVICE_DOCUMENTATION",
    "RECEIPT",
    "REFUND_POLICY",
    "CANCELLATION_POLICY",
    "OTHER",
]);
exports.paymentDisputeEvidenceStatusSchema = zod_1.z.enum([
    "MISSING",
    "READY",
    "SUBMITTED",
]);
exports.paymentDisputeSubmissionStatusSchema = zod_1.z.enum([
    "NOT_STARTED",
    "READY",
    "SUBMITTING",
    "SUBMITTED",
    "FAILED",
]);
exports.paymentDisputeActivityTypeSchema = zod_1.z.enum([
    "PROVIDER_OPENED",
    "PROVIDER_UPDATED",
    "PROVIDER_CLOSED",
    "ASSIGNED",
    "UNASSIGNED",
    "EVIDENCE_UPDATED",
    "EVIDENCE_SUBMITTED",
    "EVIDENCE_SUBMISSION_FAILED",
    "REMINDER_QUEUED",
    "PROVIDER_EVENT_RETRIED",
]);
exports.paymentProviderAccountSchema = zod_1.z.object({
    providerKey: exports.paymentProviderKeySchema.nullable(),
    environment: exports.paymentProviderEnvironmentSchema,
    status: exports.paymentProviderAccountStatusSchema,
    chargesEnabled: zod_1.z.boolean(),
    payoutsEnabled: zod_1.z.boolean(),
    requirementsDue: zod_1.z.array(zod_1.z.string()),
    onlinePaymentsEnabled: zod_1.z.boolean(),
    connectedAt: zod_1.z.string().datetime().nullable(),
    updatedAt: zod_1.z.string().datetime().nullable(),
});
exports.paymentSettingsResponseSchema = zod_1.z.object({
    account: exports.paymentProviderAccountSchema,
    canManage: zod_1.z.boolean(),
});
exports.updatePaymentSettingsRequestSchema = zod_1.z.object({
    onlinePaymentsEnabled: zod_1.z.boolean(),
});
exports.paymentOnboardingLinkSchema = zod_1.z.object({
    url: zod_1.z.string().url(),
    expiresAt: zod_1.z.string().datetime(),
});
exports.createPortalPaymentSessionRequestSchema = zod_1.z.object({
    idempotencyKey: zod_1.z.string().uuid(),
});
exports.portalPaymentSessionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    status: exports.paymentCheckoutStatusSchema,
    checkoutUrl: zod_1.z.string().url().nullable(),
    expiresAt: zod_1.z.string().datetime(),
});
exports.portalOnlinePaymentSchema = zod_1.z.object({
    status: exports.portalOnlinePaymentStatusSchema,
    checkoutSessionId: zod_1.z.string().uuid().nullable(),
    reason: zod_1.z.string().nullable(),
});
exports.paymentRefundSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    paymentId: zod_1.z.string().uuid().nullable(),
    amountCents: zod_1.z.number().int().positive(),
    status: exports.paymentRefundStatusSchema,
    requestedAt: zod_1.z.string().datetime(),
    completedAt: zod_1.z.string().datetime().nullable(),
    failureReason: zod_1.z.string().nullable(),
});
exports.paymentReconciliationCaseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    checkoutSessionId: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid(),
    status: exports.paymentReconciliationStatusSchema,
    reason: zod_1.z.enum([
        "AMOUNT_MISMATCH",
        "CURRENCY_MISMATCH",
        "BALANCE_CHANGED",
        "INVOICE_NOT_PAYABLE",
        "DISPUTE_LOST",
    ]),
    expectedAmountCents: zod_1.z.number().int().nonnegative(),
    receivedAmountCents: zod_1.z.number().int().nonnegative(),
    expectedCurrency: zod_1.z.string().length(3),
    receivedCurrency: zod_1.z.string().length(3),
    createdAt: zod_1.z.string().datetime(),
    resolvedAt: zod_1.z.string().datetime().nullable(),
});
exports.providerPaymentSummarySchema = zod_1.z.object({
    checkoutSessionId: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid(),
    paymentId: zod_1.z.string().uuid().nullable(),
    providerKey: exports.paymentProviderKeySchema,
    environment: exports.paymentProviderEnvironmentSchema,
    providerReference: zod_1.z.string().nullable(),
    amountCents: zod_1.z.number().int().positive(),
    currency: zod_1.z.string().length(3),
    status: exports.paymentCheckoutStatusSchema,
    createdAt: zod_1.z.string().datetime(),
    completedAt: zod_1.z.string().datetime().nullable(),
    refunds: zod_1.z.array(exports.paymentRefundSchema),
});
exports.paymentDisputeSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    checkoutSessionId: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid(),
    paymentId: zod_1.z.string().uuid().nullable(),
    amountCents: zod_1.z.number().int().positive(),
    currency: zod_1.z.string().length(3),
    status: exports.paymentDisputeStatusSchema,
    reason: zod_1.z.string().nullable(),
    openedAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
    closedAt: zod_1.z.string().datetime().nullable(),
});
exports.paymentDisputeListItemSchema = exports.paymentDisputeSchema.extend({
    contractVersion: zod_1.z.literal(exports.PAYMENT_DISPUTE_CONTRACT_VERSION),
    providerKey: exports.paymentProviderKeySchema,
    environment: exports.paymentProviderEnvironmentSchema,
    providerReference: zod_1.z.string().trim().min(1).max(320),
    responseDueAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    jobId: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    customerId: zod_1.z.string().uuid(),
    customerDisplayName: zod_1.z.string().trim().min(1).max(160),
    assignedMembershipId: zod_1.z.string().uuid().nullable(),
    assignedMembershipName: zod_1.z.string().trim().min(1).max(160).nullable(),
    submissionStatus: exports.paymentDisputeSubmissionStatusSchema,
    submittedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    nextReminderAt: zod_1.z.string().datetime({ offset: true }).nullable(),
});
exports.paymentDisputeListQuerySchema = pagination_1.paginationQuerySchema.extend({
    status: exports.paymentDisputeStatusSchema.optional(),
    assignment: zod_1.z.enum(["ALL", "ASSIGNED", "UNASSIGNED", "ME"]).default("ALL"),
    search: zod_1.z.string().trim().max(160).optional(),
});
exports.paymentDisputeListResponseSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.PAYMENT_DISPUTE_CONTRACT_VERSION),
    items: zod_1.z.array(exports.paymentDisputeListItemSchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema,
    canManage: zod_1.z.boolean(),
});
exports.paymentDisputeEvidenceItemSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    kind: exports.paymentDisputeEvidenceKindSchema,
    status: exports.paymentDisputeEvidenceStatusSchema,
    note: zod_1.z.string().max(4_000).nullable(),
    documentUrl: zod_1.z.string().url().max(2_048).nullable(),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.paymentDisputeActivitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: exports.paymentDisputeActivityTypeSchema,
    actorName: zod_1.z.string().trim().min(1).max(160).nullable(),
    detail: zod_1.z.string().trim().min(1).max(500),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
});
exports.paymentDisputeProviderEventDiagnosticSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    status: zod_1.z.enum([
        "PENDING",
        "PROCESSING",
        "PROCESSED",
        "FAILED",
        "REQUIRES_REVIEW",
    ]),
    attempts: zod_1.z.number().int().nonnegative(),
    safeErrorCode: zod_1.z.string().trim().min(1).max(160).nullable(),
    receivedAt: zod_1.z.string().datetime({ offset: true }),
    processedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    canRetry: zod_1.z.boolean(),
});
exports.paymentDisputeDetailResponseSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.PAYMENT_DISPUTE_CONTRACT_VERSION),
    dispute: exports.paymentDisputeListItemSchema,
    evidence: zod_1.z.array(exports.paymentDisputeEvidenceItemSchema),
    activity: zod_1.z.array(exports.paymentDisputeActivitySchema),
    providerEvents: zod_1.z.array(exports.paymentDisputeProviderEventDiagnosticSchema),
    canManage: zod_1.z.boolean(),
});
exports.assignPaymentDisputeRequestSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.PAYMENT_DISPUTE_CONTRACT_VERSION),
    assignedMembershipId: zod_1.z.string().uuid().nullable(),
});
exports.updatePaymentDisputeEvidenceRequestSchema = zod_1.z
    .object({
    contractVersion: zod_1.z.literal(exports.PAYMENT_DISPUTE_CONTRACT_VERSION),
    items: zod_1.z
        .array(zod_1.z
        .object({
        kind: exports.paymentDisputeEvidenceKindSchema,
        status: zod_1.z.enum(["MISSING", "READY"]),
        note: zod_1.z.string().trim().max(4_000).nullable(),
        documentUrl: zod_1.z.string().url().max(2_048).nullable(),
    })
        .superRefine((item, context) => {
        if (item.status === "READY" &&
            !item.note?.trim() &&
            !item.documentUrl) {
            context.addIssue({
                code: "custom",
                message: "Ready evidence requires a note or document URL.",
            });
        }
    }))
        .min(1)
        .max(6),
})
    .superRefine((value, context) => {
    if (new Set(value.items.map((item) => item.kind)).size !== value.items.length) {
        context.addIssue({
            code: "custom",
            path: ["items"],
            message: "Evidence kinds must be unique.",
        });
    }
});
exports.submitPaymentDisputeEvidenceRequestSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.PAYMENT_DISPUTE_CONTRACT_VERSION),
    idempotencyKey: zod_1.z.string().uuid(),
});
exports.retryPaymentDisputeProviderEventRequestSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.PAYMENT_DISPUTE_CONTRACT_VERSION),
    idempotencyKey: zod_1.z.string().uuid(),
});
exports.invoicePaymentProcessingResponseSchema = zod_1.z.object({
    payments: zod_1.z.array(exports.providerPaymentSummarySchema),
    disputes: zod_1.z.array(exports.paymentDisputeSchema),
    reconciliationCases: zod_1.z.array(exports.paymentReconciliationCaseSchema),
});
exports.requestFullPaymentRefundSchema = zod_1.z.object({
    reason: zod_1.z.string().trim().min(2).max(1_000),
    idempotencyKey: zod_1.z.string().uuid(),
});
exports.paymentWebhookAcknowledgementSchema = zod_1.z.object({
    accepted: zod_1.z.literal(true),
    duplicate: zod_1.z.boolean(),
});
exports.localPaymentCheckoutSchema = zod_1.z.object({
    amountCents: zod_1.z.number().int().positive(),
    currency: zod_1.z.literal("USD"),
    description: zod_1.z.string().trim().min(1).max(200),
});
exports.localPaymentCheckoutSimulationOutcomeSchema = zod_1.z.enum([
    "SUCCESS",
    "FAILED",
    "CANCELED",
    "AMOUNT_MISMATCH",
    "DUPLICATE_SUCCESS",
]);
exports.localPaymentCheckoutSimulationRequestSchema = zod_1.z.object({
    outcome: exports.localPaymentCheckoutSimulationOutcomeSchema,
});
exports.localPaymentCheckoutSimulationResponseSchema = zod_1.z.object({
    returnUrl: zod_1.z.string().url(),
});
//# sourceMappingURL=payment-processing.js.map